import { render, staticRenderFns } from "./WeekScheduleBox.vue?vue&type=template&id=7a5f638a&scoped=true&"
import script from "./WeekScheduleBox.vue?vue&type=script&lang=js&"
export * from "./WeekScheduleBox.vue?vue&type=script&lang=js&"
import style0 from "./WeekScheduleBox.vue?vue&type=style&index=0&id=7a5f638a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5f638a",
  null
  
)

export default component.exports